import { Card, TablePagination } from "@mui/material";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddDialog } from "../../../components/component/modals/AddModal";
import {
  fetchVehicleTypes,
  resetVehicle,
} from "../../../redux/slices/vehicleSlice";
import { Shadow } from "../../../routers";
import Form from "../../../sections/settings/vehicles/vehicleTypes/Form";
import EnhancedTable from "../../../sections/settings/vehicles/vehicleTypes/Table";

export default function VehicleTypes() {
  // TODO: hooks
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // TODO: useStates
  const [openAdd, setOpenAdd] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 50,
  });
  const [rows, setRows] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});

  // TODO: get the data from slice
  const vehicleTypes = useSelector((state) => state.vehicle.vehicleTypes);

  // TODO: fetching the vehicleTypes
  // TODO: fetch  when searached
  useEffect(() => {
    dispatch(resetVehicle());
    if (search) {
      const debounce = setTimeout(() => {
        dispatch(
          fetchVehicleTypes({
            enqueueSnackbar,
            limit: pagination.limit,
            page: pagination.page,
            search,
          })
        );
      }, [2000]);
      return () => clearTimeout(debounce);
    } else {
      dispatch(
        fetchVehicleTypes({
          enqueueSnackbar,
          limit: pagination.limit,
          page: pagination.page,
          search,
        })
      );
    }
  }, [
    dispatch,
    search,
    pagination.limit,
    pagination.page,
    enqueueSnackbar,
    refresh,
    selectedFilters,
  ]);

  // TODO: set the rows

  useEffect(() => {
    const data = vehicleTypes?.data?.map((vehicleType) => ({
      id: vehicleType?.id,
      name: vehicleType?.name,
      slug: vehicleType?.slug,
      logo: vehicleType?.logo,
      capacity: vehicleType?.capacity,
      status: vehicleType?.status,
      description: vehicleType?.description,
      remarks: vehicleType?.remarks,
      displayName: vehicleType?.display_name,
      is_pool_available: vehicleType?.is_pool_available,
      createdDate: moment(vehicleType?.created_at)
        .format("Do MMMM, YYYY")
        .replace(/(\d+)(th|st|nd|rd)/, "$1$2"),
    }));
    setRows(data);
  }, [vehicleTypes]);

  const filteredRows = rows?.filter((row) =>
    Object.values(row).some((value) =>
      typeof value === "string"
        ? value.toLowerCase().includes(search.toLowerCase())
        : JSON.stringify(value).toLowerCase().includes(search.toLowerCase())
    )
  );

  // TODO: functions
  const handleChangePage = (event, newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination((prev) => ({
      ...prev,
      page: 0,
      limit: parseInt(event.target.value, 10),
    }));
  };

  // TODO: console.logs

  return (
    <>
      <Shadow>
        <Card color="transparent" shadow={false}>
          <EnhancedTable
            showSearch={true}
            title="Vehicle Types"
            rows={filteredRows}
            showFilter={false}
            setOpenAdd={() => setOpenAdd((prev) => !prev)}
            page={pagination.page}
            rowsPerPage={pagination.limit}
            setRefresh={setRefresh}
            refresh={refresh}
            setSearch={setSearch}
            search={search}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />

          {/* TODO: pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            component="div"
            count={vehicleTypes?.meta?.total}
            rowsPerPage={pagination.limit}
            page={pagination.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Shadow>

      {/* TODO: add roles */}
      <AddDialog
        maxWidth="md"
        title={"Add new vehicle type"}
        open={openAdd}
        handleClose={() => setOpenAdd(false)}
      >
        <Form handleClose={() => setOpenAdd(false)} />
      </AddDialog>
    </>
  );
}
